export const DATE_FORMAT_PROP = 'dd.MM.yyyy';
export const DATE_FORMAT_FOR_PARSE = Array.from(DATE_FORMAT_PROP)
  .map((symbol) => {
    return symbol.toUpperCase();
  })
  .join('');
export const DATE_FORMAT_FOR_STORE = 'YYYY-MM-DD';
